module.exports = __webpack_public_path__ + "static/media/PartlyCloudy.beaa3377.svg";